<template>
  <CBox mt="3vw">
    <CBox
      :rounded="rounded"
      :boxShadow="boxShadow"
      :h="h"
      :w="w"
      :p="p"
      :mx="mx"
      class="cardBox"
      d="flex"
      flexDirection="column"
    >
      <CHeading
        class="cardHeading"
        :color="headingColor"
        fontSize="2vw"
        fontFamily="Noto Sans"
      >
        {{ header }}
      </CHeading>
      <CList
        mt="3vw"
        v-if="items.length"
        fontWeight="600"
        fontSize="1.2vw"
        fontFamily="Noto Sans"
      >
        <CListItem
          v-for="item in items"
          :key="item"
          m="0.8vw"
          class="cardListItem"
        >
          <CListIcon icon="chevron-right" :color="headingColor" />
          {{ item }}
        </CListItem>
      </CList>
    </CBox>
  </CBox>
</template>

<script>
import { CBox, CHeading, CList, CListItem, CListIcon } from "@chakra-ui/vue";

export default {
  name: "Card",
  data() {
    return {
      rounded: {
        type: String,
      },
      h: {
        type: String,
      },
      w: {
        type: String,
      },
      items: {
        type: Object,
      },
      header: {
        type: String,
      },
      p: {
        type: String,
      },
      mx: {
        type: String,
      },
    };
  },
  components: {
    CBox,
    CList,
    CListItem,
    CListIcon,
    CHeading,
  },
  watch: {
    h: function(newValue) {
      // this.h = newValue;
      console.log(newValue);
    },
  },
  created() {
    this.rounded = this.borderRadius;
    this.items = this.options;
    this.header = this.heading;
    this.h = this.height;
    this.w = this.width;
    this.p = this.padding;
    this.mx = this.marginX;
  },
  props: {
    borderRadius: {
      type: String,
      default: "2vw",
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    heading: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: "10vw",
    },
    width: {
      type: String,
      default: "8vw",
    },
    padding: {
      type: String,
      default: "3vw",
    },
    marginX: {
      type: String,
      default: "auto",
    },
    boxShadow: {
      type: String,
      default: "1vw 1vw 3vw 0vw #CCDDDD",
    },
    headingColor: {
      type: String,
      default: "#8D4E85",
    },
  },
};
</script>

<style>
@media screen and (max-width: 480px) {
  .cardBox {
    width: 50vw;
    height: 70vw;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .cardHeading {
    font-size: 5vw;
    padding: 4vw;
  }
  .cardListItem {
    font-size: 3vw;
    padding: 1vw;
  }
}

@font-face {
  font-family: "Noto Sans";
  src: local("Noto Sans"),
    url(../assets/fonts/NotoSans-Bold.ttf) format("truetype");
}
</style>
